import { Link } from "react-router-dom";
import CheckELogo from "@/components/CheckELogo";

/**
 * MarketingFooter — shared footer for all public/marketing pages.
 * No tagline (intentional per design decision).
 */
export default function MarketingFooter() {
  return (
    <footer className="bg-canvas border-t border-slateline-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
        <div className="flex items-center gap-3">
          <CheckELogo size={32} withWordmark />
          <span className="hidden sm:inline text-sm text-slateline-500">
            · The human review layer for AI-built work
          </span>
        </div>
        <div className="flex flex-wrap gap-x-6 gap-y-2 text-sm text-slateline-500">
          {/* Discovery — kept reachable after the nav prune (5→4 doorways).
              Browse-experts + use-cases used to live in the nav; they're now
              only here in the footer plus in-page CTAs. */}
          <Link to="/experts" className="hover:text-ink">Browse experts</Link>
          <Link to="/use-cases" className="hover:text-ink">Use cases</Link>
          <Link to="/reviewers" className="hover:text-ink">Become a reviewer</Link>
          <Link to="/about" className="hover:text-ink">About</Link>
          <Link to="/contact" className="hover:text-ink">Contact</Link>
          <Link to="/privacy" className="hover:text-ink">Privacy</Link>
          <Link to="/terms" className="hover:text-ink">Terms</Link>
          <Link to="/legal/cookies" className="hover:text-ink">Cookies</Link>
          <Link to="/legal/subprocessors" className="hover:text-ink">Sub-processors</Link>
          {/* Re-open the consent banner (the Cookie Policy references this as
              "Cookie settings"). Clears the stored choice + reloads. */}
          <button
            type="button"
            onClick={() => {
              try {
                localStorage.removeItem("xpert_cookie_choice");
                delete window.__xpertCookieChoice;
              } catch { /* ignore */ }
              window.location.reload();
            }}
            className="hover:text-ink"
          >
            Cookie settings
          </button>
        </div>
      </div>
    </footer>
  );
}
